export const guideCards = [
  {
    image: "/Assets/Images/Kanban.svg",
    bg_color: "var(--light-neutral-2)",
    text_color: "var(--primary-dark-1)",
    text: {
      en: "Learn something new",
      hi: "नया सीखें",
      or: "କିଛି ନୂଆ ଶିଖନ୍ତୁ"
    }
  },
  {
    image: "/Assets/Images/Lightbulb.svg",
    bg_color: "var( --light-neutral-10)",
    text_color: "var(--dark-neutral-5)",
    text: {
      en: "Revise old again",
      hi: "पुराना दोहरायें",
      or: "ପୁରୁଣାକୁ ପୁଣିଥରେ ଦୋହରାନ୍ତୁ"
    }
  },
  {
    image: "/Assets/Images/SealQuestion.svg",
    bg_color: "var(--light-neutral-11)",
    text_color: "var(--green-4)",
    text: {
      en: "Ask questions, get answers",
      hi: "सवाल पूछें और उत्तर पाएं!",
      or: "ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ, ଉତ୍ତର ପାଆନ୍ତୁ"
    }
  },
  {
    image: "/Assets/Images/Clock.svg",
    bg_color: "var(--light-neutral-12)",
    text_color: "var(--dark-neutral-6)",
    text: {
      en: "Learn anytime, don’t refrain",
      hi: "कभी भी सीखें,  बेझिझक आएँ",
      or: "ଯେକୌଣସି ସମୟରେ ଶିଖନ୍ତୁ, ସଙ୍କୋଚ କରନ୍ତୁ ନାହିଁ!"
    }
  }
];

export const guideAudio = {
  en: "Talk to HealthVaani, see the gain. Learn something new. Revise old again. Ask questions, get answers. Learn anytime, don’t refrain",
  hi: "हेल्थवाणी से बात कर लाभ उठाएँ. नया सीखें. पुराना दोहरायें. सवाल पूछें और उत्तर पाएं! कभी भी सीखें,  बेझिझक आएँ",
  or: "ହେଲ୍‌ଥବାଣୀ ସହ କଥା ହୁଅନ୍ତୁ, ଲାଭ ଦେଖନ୍ତୁ। କିଛି ନୂଆ ଶିଖନ୍ତୁ. ପୁରୁଣାକୁ ପୁଣିଥରେ ଦୋହରାନ୍ତୁ. ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ, ଉତ୍ତର ପାଆନ୍ତୁ. ଯେକୌଣସି ସମୟରେ ଶିଖନ୍ତୁ, ସଙ୍କୋଚ କରନ୍ତୁ ନାହିଁ!"
}

export const guideHeading = {
  en: "Talk to HealthVaani, see the gain",
  hi: "हेल्थवाणी से बात कर लाभ उठाएँ",
  or: "ହେଲ୍‌ଥବାଣୀ ସହ କଥା ହୁଅନ୍ତୁ, ଲାଭ ଦେଖନ୍ତୁ।"
}

export const guideButtons = {
  next: {
    en: "Chat Now",
    hi: "मुझसे बात करें",
    or: "ବର୍ତ୍ତମାନ ଚାଟ୍ କରନ୍ତୁ",
  },
  stop: {
    en: "Click to stop",
    hi: "रोकने के लिए क्लिक करें",
    or: "ବନ୍ଦ କରିବାକୁ କ୍ଲିକ୍ କରନ୍ତୁ"
  }
};